<template>
  <div id="trailHub">
    <div class="container">
      <h1>Trail Hub</h1>
      <form @submit.prevent>
        <div class="form-group">
          <label>Trail System ID</label>
          <input
            class="form-control"
            v-model="dashboard.data.modules.trailHub.tsID"
            :placeholder="dashboard.data.modules.trailHub.tsID"
          />
        </div><!-- /.form-group -->
        <div class="mb-3">
          <label>Default Activity</label>
          <b-form-select
            v-model="dashboard.data.modules.trailHub.defaultActivity"
            :options="defaultActivities"
          ></b-form-select>
        </div>

        <button
          class="btn btn-primary"
          @click="saveSettings()"
        >
          Save Settings
        </button>
      </form>
    </div><!-- /.container -->
  </div><!-- /#trailHub -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../../../firebaseConfig.js')

export default {
  data () {
    return {
      defaultActivities: [
        {
          value: {
            label: 'Mountain Biking',
            value: 'mountainBiking',
            iconClass: 'fas fa-biking-mountain'
          },
          text: 'Mountain Biking'
        },
        {
          value: {
            label: 'Nordic Skiing',
            value: 'nordicSkiing',
            iconClass: 'fas fa-skiing-nordic'
          },
          text: 'Nordic Skiing' }
      ]
    }
  },
  computed: {
    ...mapState([
      'userProfile',
      'currentUser',
      'admin',
      'dashboard',
      'modules'
    ])
  },
  methods: {
    saveSettings() {
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        alert('Successfully updated settings!')
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
      }).catch(err => {
        console.log(err.message)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/modules/TrailHub.vue